import { PureComponent } from 'react'

export class EvaluationPrint extends PureComponent {
    render() {
        return (
            <>
                <h1>Drucken</h1>
            </>
        )
    }
}
